/**
 * Map Markers Utilities
 *
 * This module handles all property marker operations for the Interactive Survey Market Map.
 * It provides functions to create, update, and manage property markers on the map.
 */

import { Property } from "@/features/survey/types";
import { MutableRefObject } from "react";

// Types for marker management
export interface MarkerRefs {
  markersRef: MutableRefObject<mapboxgl.Marker[]>;
  currentPopupRef: MutableRefObject<mapboxgl.Popup | null>;
}

/**
 * Clears all markers from the map
 */
export const clearMarkers = (
  refs: MarkerRefs,
  setSelectedProperty: (property: Property | null) => void,
): void => {
  setSelectedProperty(null);
  refs.markersRef.current.forEach((marker) => marker.remove());
  refs.markersRef.current = [];
  // Note: Don't clear radius circles here as they should persist across marker refreshes
};
